import { useEffect, useState } from 'react';
import moment from 'moment';
import { useGetMyActiveDelegations } from '../../../apis/hooks/delegation';

// Shows a banner when the logged-in user currently holds delegated approval
// authority from someone else ("acting for X until <date>"). Self-contained so
// it can be dropped anywhere in the authenticated layout.
const DelegationBanner = () => {
    const { mutate: getMyActiveDelegations } = useGetMyActiveDelegations();
    const [active, setActive] = useState<any[]>([]);

    useEffect(() => {
        const staffId = localStorage.getItem('loggedin_user_id') ?? '';
        if (!staffId) return;
        getMyActiveDelegations(
            { staffId },
            {
                onSuccess: (res: any) => {
                    setActive(Array.isArray(res?.data?.records) ? res.data.records : []);
                },
            },
        );
    }, []);

    if (!active.length) return null;

    return (
        <div
            className='alert alert-warning d-flex align-items-center mb-0 py-2 px-3'
            role='alert'
            style={{ borderRadius: 8 }}>
            <span className='me-2'>🔑</span>
            <span>
                {active.map((d, i) => (
                    <span key={d?._id || i}>
                        {i > 0 && ' | '}
                        You are acting on behalf of <strong>{d?.delegatedFromName || 'a user'}</strong>
                        {d?.endDate ? ` until ${moment(d.endDate).format('DD-MM-YYYY')}` : ''}
                    </span>
                ))}
            </span>
        </div>
    );
};

export default DelegationBanner;
